var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInTreatment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.04481 4.03278C3.14802 3.87797 3.26626 3.73374 3.39782 3.60218L3.54087 3.45913C4.41379 2.58621 5.74479 2.36412 6.85384 2.90632L6.96452 2.96043C7.28694 3.11806 7.6411 3.2 8 3.2C8.3589 3.2 8.71306 3.11806 9.03548 2.96043L9.14616 2.90632C10.2552 2.36412 11.5862 2.58621 12.4591 3.45913L12.6022 3.60218C12.7337 3.73374 12.852 3.87797 12.9552 4.03278C13.5879 4.98181 13.5879 6.21819 12.9552 7.16722L12.7424 7.48647C11.9975 8.60378 11.6 9.91657 11.6 11.2594V12.0836C11.6 12.5547 11.4903 13.0194 11.2796 13.4408L11.2596 13.4807C11.1005 13.799 10.7752 14 10.4194 14C10.0436 14 9.70402 13.7761 9.556 13.4307L8.84491 11.7715C8.52655 11.0286 7.47345 11.0286 7.15509 11.7715L6.44401 13.4307C6.29598 13.7761 5.95635 14 5.58057 14C5.22476 14 4.89948 13.799 4.74036 13.4807L4.7204 13.4408C4.50969 13.0194 4.4 12.5547 4.4 12.0836V11.2594C4.4 9.91657 4.00252 8.60378 3.25765 7.48647L3.04481 7.16722C2.41213 6.21819 2.41213 4.98181 3.04481 4.03278Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInTreatment);
export default __webpack_public_path__ + "static/media/In_treatment.ae11c8cccd8c761f1f5ce4eefc139408.svg";
export { ForwardRef as ReactComponent };